module.exports = __webpack_public_path__ + "img/01@2x.423edb68.png";